import React from 'react';
import { useTranslation } from 'react-i18next';
import { spamBand, meterBars, formatScore } from './spamRules';

/**
 * The reading pane's spam pill (owner mockup 08.09.2026): `Spam ▌▌▌▌▌ 0.4` —
 * label, a five-bar meter, the score in mono. Green / amber / red through the
 * `--mailc-spam-<band>` variables. A button: clicking it opens the reasons
 * modal. The meter is decorative (`aria-hidden`); the accessible name carries
 * the numbers.
 */
export default function SpamPill({ score = 0, threshold, onOpen }) {
  const { t } = useTranslation();
  const band = spamBand(score, threshold);
  const bars = meterBars(score, threshold);
  const label = t('mailCatcher.spam.pillAria', { score: formatScore(score), threshold: formatScore(threshold) });
  return (
    <button
      type="button"
      className={`mailc-spam-pill mailc-spam-pill--${band}`}
      onClick={onOpen}
      aria-label={label}
      title={label}
      data-testid="mail-spam-pill"
      data-band={band}
    >
      <span className="mailc-spam-pill-label">{t('mailCatcher.spam.label')}</span>
      <span className="mailc-spam-meter" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <i key={i} className={`mailc-spam-bar${i < bars ? ' mailc-spam-bar--on' : ''}`} data-testid="mail-spam-bar" data-on={i < bars ? 'true' : 'false'} />
        ))}
      </span>
      <span className="mailc-spam-score">{formatScore(score)}</span>
    </button>
  );
}
